var map = {
	"./crm/CRMCanbanDatatableActions.vue": 70140,
	"./crm/CRMFeedbackDatatableActions.vue": 1772,
	"./crm/CRMLeadDatatableActions.vue": 44669,
	"./crm/CRMRecordDatatableActions.vue": 30183,
	"./crm/CRMSiteFormDatatableActions.vue": 92488,
	"./crm/CRMTaskDatatableActions.vue": 97555,
	"./egisz/EGISZDatatableActions.vue": 78872,
	"./laboratories/LaboratoryOrdersDatatableActions.vue": 74634,
	"./laboratories/LaboratoryServiceDatatableActions.vue": 7124,
	"./marketing/MarketingGroupDatatableActions.vue": 10822,
	"./marketing/MarketingMailingDatatableActions.vue": 82903,
	"./marketing/MarketingNotificationAllDatatableActions.vue": 2821,
	"./marketing/MarketingNotificationDatatableActions.vue": 50427,
	"./patients/GeneralDatatablePlanTreatmentActions.vue": 2908,
	"./patients/PatientDatatableAIPhotoStudyActions.vue": 32412,
	"./patients/PatientDatatableActions.vue": 94023,
	"./patients/PatientDatatableAdvanceActions.vue": 14408,
	"./patients/PatientDatatableNotificationActions.vue": 65077,
	"./patients/PatientDatatablePlanTreatmentActions.vue": 40342,
	"./patients/PatientDatatableRecordActions.vue": 88018,
	"./patients/PatientDatatableReportPopulatedActions.vue": 42145,
	"./patients/PatientWaitingListDatatableActions.vue": 88000,
	"./patients/PaymentDatatableActions.vue": 14370,
	"./planning/PlanningPatientDatatableActions.vue": 14900,
	"./services/ServicesDatatableActionsArchive.vue": 85579,
	"./services/ServicesDatatableActionsPrice.vue": 89362,
	"./services/ServicesDatatableActionsServiceCategory.vue": 13961,
	"./staff/StaffDatatableAdministratorActions.vue": 88573,
	"./staff/StaffDatatableAssistantActions.vue": 57608,
	"./staff/StaffDatatableChairActions.vue": 6481,
	"./staff/StaffDatatableCuratorActions.vue": 9246,
	"./staff/StaffDatatableDoctorActions.vue": 76545,
	"./staff/StaffDatatableRecordActions.vue": 38755,
	"./staff/StaffDatatableTechnicActions.vue": 99378,
	"./superadmin/SuperAdminClinicAPIActions.vue": 89309,
	"./superadmin/SuperAdminClinicsActions.vue": 15811,
	"./superadmin/SuperAdminGenericAgreementTemplatesActions.vue": 89581,
	"./superadmin/SuperAdminGenericContractTemplatesActions.vue": 73446,
	"./superadmin/SuperAdminOnlineContractActions.vue": 18373,
	"./superadmin/SuperAdminPatientsActions.vue": 34116,
	"./superadmin/SuperAdminPaymentActions.vue": 20574,
	"./superadmin/SuperAdminTariffActions.vue": 43574,
	"./superadmin/SuperAdminUsersActions.vue": 93410,
	"./templates/TemplateTextTemplatesDatatableActions.vue": 25859,
	"./warehouse/WarehouseDatatableActionsMaterialStock.vue": 10756,
	"./warehouse/WarehouseDatatableActionsOperation.vue": 98497,
	"./warehouse/WarehouseDatatableActionsWarehouse.vue": 49735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7856;